import { render, staticRenderFns } from "./TsoftIcon.vue?vue&type=template&id=d8126492"
import script from "./TsoftIcon.vue?vue&type=script&lang=js"
export * from "./TsoftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports